import { SubCard } from './chunk-SUV3QDQH.js';
import * as React from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function BatchItems({ items, noun, renderItem }) {
  const [page, setPage] = React.useState(0);
  const size = 10;
  const active = Math.min(page, Math.max(0, Math.ceil(items.length / size) - 1));
  const start = active * size;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    items.slice(start, start + size).map((item, offset) => /* @__PURE__ */ jsx(
      SubCard,
      {
        caption: `${noun} ${start + offset + 1} of ${items.length}`,
        children: renderItem(item, start + offset)
      },
      start + offset
    )),
    items.length > size && /* @__PURE__ */ jsxs("nav", { "aria-label": `${noun} pages`, className: "flex flex-wrap items-center gap-3 text-xs", children: [
      /* @__PURE__ */ jsxs("button", { type: "button", className: "rounded border px-2 py-1 disabled:opacity-40", disabled: active === 0, onClick: () => setPage(active - 1), children: [
        "Previous ",
        noun.toLowerCase(),
        "s"
      ] }),
      /* @__PURE__ */ jsxs("span", { "aria-live": "polite", children: [
        start + 1,
        "\u2013",
        Math.min(start + size, items.length),
        " of ",
        items.length
      ] }),
      /* @__PURE__ */ jsxs("button", { type: "button", className: "rounded border px-2 py-1 disabled:opacity-40", disabled: start + size >= items.length, onClick: () => setPage(active + 1), children: [
        "Next ",
        noun.toLowerCase(),
        "s"
      ] })
    ] })
  ] });
}

export { BatchItems };
//# sourceMappingURL=chunk-XCLMC7TS.js.map
//# sourceMappingURL=chunk-XCLMC7TS.js.map